import { useCallback } from 'react';
import { useConfigInputs, useConfigActions, useVendorCtx } from 'shared/state/configContexts';
import { calculateNetworkPorts } from 'utils/networkPorts';
import { resolveNetworkingOptions } from './networkingOptions';

export function useNetworkingSection() {
  const { config } = useConfigInputs();
  const { updateConfig } = useConfigActions();
  const { vendor } = useVendorCtx();
  const { interfaceOptions, protocolOptions } = resolveNetworkingOptions(vendor.capabilities);
  return {
    interfaceOption: config.interfaceOption,
    interfaceOptions,
    onInterfaceChange: useCallback((value: string) => updateConfig({ interfaceOption: value }), [updateConfig]),
    networkProtocol: config.networkProtocol,
    protocolOptions,
    onProtocolChange: useCallback((value: string) => updateConfig({ networkProtocol: value }), [updateConfig]),
    // Derived, not stored — the same arithmetic classic's config cards print.
    networkPorts: calculateNetworkPorts(config, vendor.capabilities).totalPorts as number,
    summary: [config.interfaceOption, config.networkProtocol].filter(Boolean).join(' · '),
    // Networking always has a default interface — it can never be empty.
    status: 'ok' as const,
  };
}
